export const ENABLED_FILTER_ALL = 'all';
export const ENABLED_FILTER_ENABLED = 'enabled';
export const ENABLED_FILTER_DISABLED = 'disabled';

export const STATUS_FILTER_OPTIONS = ['healthy', 'failures', 'error', 'never_run'];

export const STATUS_FILTER_LABEL_IDS = {
    healthy: 'monitoring.status.healthy',
    failures: 'monitoring.status.failures',
    error: 'monitoring.status.error',
    never_run: 'monitoring.status.neverRun',
};

export function filterSourcesByEnabled(sources, enabledFilter) {
    if (enabledFilter === ENABLED_FILTER_ALL) {
        return sources;
    }
    if (enabledFilter === ENABLED_FILTER_ENABLED) {
        return sources.filter((source) => source.enabled !== false);
    }
    return sources.filter((source) => source.enabled === false);
}

export function filterSourcesByStatus(sources, selectedStatuses) {
    if (!selectedStatuses?.length) {
        return sources;
    }
    const allowed = new Set(selectedStatuses);
    return sources.filter((source) => allowed.has(source.status));
}

export function filterSources(sources, enabledFilter, selectedStatuses) {
    return filterSourcesByStatus(filterSourcesByEnabled(sources, enabledFilter), selectedStatuses);
}
